import { CurrencyPaymentStatus } from '@/interfaces/billing'
import { Check, Clock, DollarSign, Undo2 } from 'lucide-react'

function classNames(...classes: string[]) {
  return classes.filter(Boolean)?.join(' ') ?? ' '
}

export interface CurrencyPaymentStatusFlags {
  isPrepaidPayment: boolean
  isARefund: boolean
  paymentConfirmed: boolean
  isPartialPayment: boolean
}

export const resolveStatus = ({
  isPrepaidPayment,
  isARefund,
  paymentConfirmed,
  isPartialPayment,
}: CurrencyPaymentStatusFlags): CurrencyPaymentStatus => {
  switch (true) {
    case isARefund:
      return 'REFUND'
    case isPrepaidPayment:
      return 'PREPAID_PAYMENT'
    case isPartialPayment:
      return 'PARTIAL_PAYMENT'
    case paymentConfirmed:
      return 'CONFIRMED_PAYMENT'
    default:
      return 'CONFIRMED_PAYMENT'
  }
}

export const statusConfig: Record<
  CurrencyPaymentStatus,
  { label: string; color: string; icon: React.ReactNode }
> = {
  REFUND: {
    label: 'Reembolsado',
    color: 'bg-violet-200 text-violet-800',
    icon: <Undo2 className="mr-2 h-3 w-3" />,
  },
  PREPAID_PAYMENT: {
    label: 'Anticipado',
    color: 'bg-yellow-100 text-yellow-800',
    icon: <DollarSign className="mr-2 h-3 w-3" />,
  },
  PARTIAL_PAYMENT: {
    label: 'Parcial',
    color: 'bg-blue-100 text-blue-800',
    icon: <Clock className="mr-2 h-3 w-3" />,
  },
  CONFIRMED_PAYMENT: {
    label: 'Confirmado',
    color: 'bg-green-100 text-green-800',
    icon: <Check className="mr-2 h-3 w-3" />,
  },
}

export const CurrencyPaymentStatusBadge = ({
  isPrepaidPayment,
  isARefund,
  paymentConfirmed,
  isPartialPayment,
}: CurrencyPaymentStatusFlags) => {
  const status = resolveStatus({
    isPrepaidPayment,
    isARefund,
    paymentConfirmed,
    isPartialPayment,
  })
  const { label, color, icon } = statusConfig[status]

  return (
    <div
      className={classNames(
        color,
        'inline-flex flex-shrink-0 items-center rounded-full px-2.5 py-0.5 text-sm font-medium md:mt-2 lg:mt-0'
      )}
    >
      <div className="flex items-center justify-center">{icon}</div>
      <span className="truncate">{label}</span>
    </div>
  )
}
